import { word } from "@modules/core/utils/i18n"
import { PayoutTransferStatus } from "@modules/finances/types/financesType"
import { BalanceTransactionType } from "@modules/financesPayout/gateway/payoutDto"

export const getPayoutStatusWord = (status: PayoutTransferStatus) => {
  switch (status) {
    case PayoutTransferStatus.PAID:
      return word("payoutTransferStatus.paid")
    case PayoutTransferStatus.IN_TRANSIT:
      return word("payoutTransferStatus.inTransit")
    case PayoutTransferStatus.CANCELED:
      return word("payoutTransferStatus.canceled")
    case PayoutTransferStatus.FAILED:
      return word("payoutTransferStatus.failed")
    case PayoutTransferStatus.PENDING:
      return word("payoutTransferStatus.pending")
    default:
      return ""
  }
}

export const getWordBalanceTransaction = (balanceTransactionType: BalanceTransactionType) => {
  switch (balanceTransactionType) {
    case BalanceTransactionType.ADJUSTMENT:
      return word("balanceTransactionType.adjustment")
    case BalanceTransactionType.CHARGE:
      return word("balanceTransactionType.charge")
    case BalanceTransactionType.REFUND:
      return word("balanceTransactionType.refund")
    case BalanceTransactionType.PAYMENT:
      return word("balanceTransactionType.payment")
    case BalanceTransactionType.STRIPE_FEE:
      return word("balanceTransactionType.stripFee")
    default:
      return balanceTransactionType
        .split("_")
        .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
        .join(" ")
  }
}
